import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
/**
 * 校验生命状态的 hook
 * @returns {Object} 包含校验方法的对象
 */
export const useLifeStatus = () => {
  const { t } = useI18n();
  /**
   * 校验生命状态
   * @param {Array} selectIds 选中的数据ID列表
   * @param {Array} tableData 表格数据
   * @param {string} promptTitle 操作标题
   * @returns {boolean} 是否全部为审批中状态
   */
  const checkLifeStatus = (selectIds, tableData, promptTitle) => {
    let isAllStatusOrigin1 = false;
    if (selectIds && selectIds.length) {
      isAllStatusOrigin1 = selectIds.every((item) => {
        const tableItem = tableData.find((t) => t.id == item);
        return tableItem && tableItem.statusOrigin == 1;
      });
    }
    if (isAllStatusOrigin1) {
      const msg = `${t('审批中的数据不允许')}${promptTitle}！`;
      Message.error(msg);
    }
    return isAllStatusOrigin1;
  };

  return {
    checkLifeStatus
  };
};
